import {ActionContext} from "vuex";
import {State as RootState} from "@/store";
import {getStoreAccessors} from "vuex-typescript";
import {ChannelState} from "@/store/Channel/ChannelState";
import {Channel, Topic} from "@/repository/messagehub.dtos";
import {topicRecord, TopicState} from "@/store/Topic";
import {TopicApi} from "@/repository/TopicApi";


type ChannelRecordContext = ActionContext<ChannelState, RootState>;

export const channelRecord = {
    namespaced: true,

    state: {
        channels: [],
        selectedChannel: ''
    },

    getters: {
        getChannels(state: ChannelState): any{
            return state.channels
        },
        getSelectedChannel(state: ChannelState): any {
            return state.selectedChannel
        }
    },

    mutations: {
        mutateAddChannel: function(state: ChannelState, newChannel: Channel){
            if (state.channels !=null && state.channels.length >0){
                state.channels.push(newChannel)
            }
            else{
                state.channels = []
                state.channels.push(newChannel)
            }

        },
        mutateDeleteChannel: function(state: ChannelState, deletedChannel: Channel){
          if (state.channels !=null && state.channels.length >0)  {
              let idx:number = state.channels.indexOf(deletedChannel);
              if (idx != -1) {
                  state.channels.splice(idx,1)
                  state.selectedChannel = null
              }
          }
        },
        mutateInitializeChannels: function(state: ChannelState, channels: Channel[]){
            state.channels = channels
            state.selectedChannel = channels[0]
        },
        mutateSelectedChannelChanged:function(state: ChannelState, selectedChannel: Channel){
            console.log('mutating channel selection')
            state.selectedChannel = selectedChannel

        }
    },
    actions: {
        addChannel: function (context: ChannelRecordContext, newChannel: Channel){
            commitAddChannel(context, newChannel)
        },
        deleteChannel: function (context: ChannelRecordContext, deletedChannel: Channel){
            commitDeleteChannel(context, deletedChannel)
        },
        initializeChannels: function (context: ChannelRecordContext, channels: Channel[]){
            commitInitializeChannels(context, channels)
        },
        selectedChannelChangedAction:  function (context: ChannelRecordContext, selectedChannel: Channel){
            context.dispatch("topicRecord/selectedTopicChanged", null, {root: true})
            topicApi.getTopicsInChannel(selectedChannel.id).then(success=>{
                context.dispatch("topicRecord/initializeTopics", <Topic[]> success.data, {root: true})
                commitSelectedChannelChanged(context, selectedChannel)
            })


        },
    },
};
const { commit, read, dispatch } =
    getStoreAccessors<ChannelState, RootState>("channelRecord");

const getters:any = channelRecord.getters;
export const getChannels:any = read(getters.getChannels);
export const getSelectedChannel:any = read(getters.getSelectedChannel);

const actions: any = channelRecord.actions;
export const deleteChannel:any =dispatch(actions.deleteChannel)
export const initializeChannels:any =dispatch(actions.initializeChannels)
export const selectedChannelChangedAction:any =  dispatch(actions.selectedChannelChangedAction)
export const addChannel:any =dispatch(actions.addChannel)

const mutations:any = channelRecord.mutations;
export const commitDeleteChannel:any = commit(mutations.mutateDeleteChannel);
export const commitInitializeChannels:any = commit(mutations.mutateInitializeChannels);
export const commitSelectedChannelChanged:any = commit(mutations.mutateSelectedChannelChanged);
export const commitAddChannel:any = commit(mutations.mutateAddChannel);

// topic store

const topicApi = new TopicApi()
